import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  inject,
} from '@angular/core';
import { SwiperContainerComponent } from './swiper-container.component';
import { SwiperSlide } from 'swiper/element';
import { BehaviorSubject, fromEvent, map, startWith, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'swiper-slide',
  standalone: true,
  template: '<ng-content />',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwiperSlideComponent implements AfterViewInit {

  private readonly destroyRef = inject(DestroyRef);
  private readonly swiperContainer = inject(SwiperContainerComponent, { host: true } );

  public readonly elementRef = inject<ElementRef<SwiperSlide>>(ElementRef);

  private readonly activeSubject = new BehaviorSubject<boolean>(false);
  public readonly active$ = this.activeSubject.asObservable();

  public ngAfterViewInit() {
    const swiper = this.swiperContainer.elementRef.nativeElement.swiper;

    fromEvent(swiper, 'slidesUpdated').pipe(
      startWith(null),
      map(() => swiper.slides.findIndex((slide) => {
        return slide === this.elementRef.nativeElement;
      })),
      switchMap((index) => fromEvent(swiper, 'slideChange').pipe(
        map(() => index === swiper.realIndex),
        startWith(index === swiper.realIndex),
      )),
      distinctUntilChanged(),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((active) => {
      this.activeSubject.next(active);
    });
  }

}
